import request from './require.js';
const api = {
  getData (param) {
    return request({
      url: '/static/testdata.json',
      method: 'get',
      data: param
    });
  }
};
export default api;
